import React, { useState } from 'react'
import useData from '../hooks/useData'
import Loading from './Loading'
import Input from './Input'
import { post, put } from '../modules/fetch'
import { debounce } from '../modules/helpers'
import Icon from './Icon'
import Confirmation from './Confirmation'

const save = debounce((id, key, value) => put('menu_item/' + id, { [key]: value }), 1000)
const MenuItem = (props) => {
    const { menu_items, label, id, parent_id, site_id, article_id, fetchSite, fetchArticles, createMenuItem } = props

    const onChange = (key, value) =>
        fetchSite.setState({
            ...fetchSite.data,
            menu_items: [
                ...fetchSite.data.menu_items.reduce((acc, i) => {
                    if (i.id !== id) {
                        acc.push(i)
                    } else {
                        acc.push({ ...i, [key]: value?.value || value })
                    }
                    return acc
                }, []),
            ],
        }) || save(id, key, value?.value || value)
    console.log(
        [
            { label: 'Select an article', value: '' },
            ...((fetchArticles &&
                fetchArticles.isReady &&
                fetchArticles.data &&
                fetchArticles.data.filter((a) => a.published && a.active).map((i) => ({ label: i.title, value: i.id }))) ||
                []),
        ].filter(Boolean)
    )
    return (
        <div className="ml-5 my-3">
            {(parent_id && (
                <div className={(props.deleting && 'deleting') || ''}>
                    <div className="input-group">
                        <Input type="text" value={label} onChange={(e) => onChange('label', e.target.value)} />
                        <div className="input-group-append">
                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault()
                                    props.delete({ id, label })
                                }}
                            >
                                <Icon name="trash" />
                            </button>
                        </div>
                    </div>
                    <Input
                        type="select"
                        className={(!article_id && 'is-invalid') || ''}
                        disabled={fetchArticles.isLoading}
                        isLoading={fetchArticles.isLoading}
                        options={[
                            { label: 'Select an article', value: '' },
                            ...((fetchArticles &&
                                fetchArticles.isReady &&
                                fetchArticles.data &&
                                fetchArticles.data.filter((a) => a.published && a.active).map((i) => ({ label: i.title, value: i.id }))) ||
                                []),
                        ].filter(Boolean)}
                        value={article_id || ''}
                        onChange={(e) => onChange('article_id', e)}
                    />
                    <div className="btn btn-light my-1" onClick={() => createMenuItem({ site_id, parent_id: id })}>
                        <Icon name="plus" /> Add sub-menu to {label}
                    </div>
                </div>
            )) || (
                <div className={(props.deleting && 'text-muted') || ''}>
                    <Input type="text" value={label} onChange={(e) => onChange('label', e.target.value)} label="Navigation name" />
                    <div className="btn btn-light my-1" onClick={() => createMenuItem({ site_id, parent_id: id })}>
                        <Icon name="plus" /> Create a menu
                    </div>
                </div>
            )}
            {menu_items &&
                menu_items
                    .filter((i) => i.parent_id == id)
                    .map((i) => (
                        <MenuItem
                            key={`menu${i.id}`}
                            fetchSite={fetchSite}
                            fetchArticles={fetchArticles}
                            menu_items={menu_items}
                            createMenuItem={createMenuItem}
                            delete={props.delete}
                            {...i}
                        />
                    ))}

            {/* <div className="my-3" onClick={() => createMenuItem({ site_id, parent_id: parent_id })}>Add new</div> */}
        </div>
    )
}

const Menu = (props) => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    let fetchSite = useData('site/' + id + '?scope=view')
    let fetchArticles = useData('article/?scope=list&site_id=' + id)

    const [display_delete_modal, set_display_delete_modal] = useState(false)
    const [delete_target, set_delete_target] = useState({})

    const createMenuItem = (params) => {
        post('menu_item', { ...params, active: 1 })
            .then((r) => console.log(r) || r)
            .then((r) => fetchSite.setState({ ...fetchSite.data, menu_items: [...fetchSite.data.menu_items, r] }))
    }

    const markMenuAsBeingDeleted = (menu_item_id) =>
        fetchSite.setState({
            ...fetchSite.data,
            menu_items: fetchSite.data.menu_items.reduce((acc, i) => {
                acc.push((i.id !== menu_item_id && i) || { ...i, deleting: true })
                return acc
            }, []),
        })
    const deleteMenuItem = (menu_item_id) =>
        markMenuAsBeingDeleted(menu_item_id) ||
        put('menu_item/' + menu_item_id, { active: 0 }).then((r) =>
            fetchSite.setState({ ...fetchSite.data, menu_items: fetchSite.data.menu_items.filter((m) => m.id !== menu_item_id) })
        )

    return (
        <>
            {(!fetchSite.isLoading && fetchSite.data && (
                <>
                    {fetchSite.data.menu_items
                        .filter((mi) => !mi.parent_id)
                        .map((mi) => (
                            <div key={`menu-${mi.id}`}>
                                <MenuItem
                                    {...mi}
                                    fetchSite={fetchSite}
                                    fetchArticles={fetchArticles}
                                    menu_items={fetchSite.data.menu_items.filter((m) => m.active)}
                                    createMenuItem={createMenuItem}
                                    delete={(target) => {
                                        set_delete_target(target)
                                        set_display_delete_modal(true)
                                    }}
                                />
                            </div>
                        ))}
                    <Confirmation
                        isOpen={display_delete_modal}
                        toggle={() => set_display_delete_modal(false)}
                        confirm={() => console.log('hey!') || deleteMenuItem(delete_target.id)}
                        title={'Delete'}
                        text={`Are you sure you want to delete ${delete_target.label}?`}
                    />
                </>
            )) || <Loading text="Loading site data" />}
        </>
    )
}

export default Menu
